import screen from './List';

export default screen;



// WEBPACK FOOTER //
// ./src/screens/admin/Equipe/List/index.js